import { render, staticRenderFns } from "./testMview.vue?vue&type=template&id=d212683c&"
import script from "./testMview.vue?vue&type=script&lang=js&"
export * from "./testMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports